module.exports = __webpack_public_path__ + "img/doorsensor.76460937.png";